import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import { useBadges } from '@mediashop/catalog-base/hooks/useBadges';
import Badge from '@mediashop/catalog-base/pattern/atom/Badge';
import classnames from 'classnames';
import { CroppedImageVariant } from '@mediashop/base/types/imageVariants';
import CroppedImage from '@mediashop/base/pattern/atom/CroppedImage';
import Currency from '@mediashop/base/pattern/atom/Currency';
import Icon from '@mediashop/base/pattern/atom/Icon';
import { BundleItemProps } from './index';
import NoImageAvailable from '../../../../assets/images/NoImageAvailable.jpg';
import parseHtml from 'html-react-parser';
import { useNavigate } from '@mediashop/app/hooks/useNavigate';

const componentName = 'bundle-item';

const BundleItem = ({ product }: BundleItemProps): JSX.Element => {
    const navigate = useNavigate();
    const variant = product.variants.find((variant) => variant.price);

    const onClick = () => {
        navigate({ pathname: `p/${product.slug}`, search: '' });
    };

    const { detailBadges } = useBadges({
        product,
        variant,
        isPDP: true,
    });
    const priceClass = detailBadges.length ? `price-colored-${detailBadges[0]?.badgeProps?.style}` : ``;

    return (
        <>
            {variant && (
                <div className={componentName} onClick={onClick}>
                    <div className={`${componentName}__inner-wrapper`}>
                        <div className={`${componentName}__image-container`}>
                            <CroppedImage
                                altText={variant.attributes.name}
                                className={`${componentName}__image`}
                                src={variant.imageUri ?? NoImageAvailable}
                                variant={CroppedImageVariant.Bundle}
                            />
                        </div>
                        <div className={`${componentName}__info-container`}>
                            <h3 className={`${componentName}__title`}>{variant.attributes.name}</h3>

                            {variant.attributes.claim ? (
                                <div className={`${componentName}__claim`}>{parseHtml(variant.attributes.claim)}</div>
                            ) : (
                                SKIP_RENDER
                            )}

                            <div className={`${componentName}__price-container`}>
                                <span className={classnames(`${componentName}__price`, priceClass)}>
                                    <Currency price={variant.price} />
                                </span>
                                {detailBadges.length ? (
                                    <Badge size="small" cornerPosition="bottom-left" {...detailBadges[0].badgeProps} />
                                ) : (
                                    SKIP_RENDER
                                )}
                            </div>
                        </div>
                        <div className={`${componentName}__icon`}>
                            <Icon name="ArrowRight" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default BundleItem;
